module.exports = __webpack_public_path__ + "media/images/icons/notification_info-1cd4d34e81a0220f57632520fa981864.svg";